export default function normalizeReturnUrl(returnUrl) {
  const benefitsIntakeSubmission =
    sessionStorage.getItem('view:form0803BenefitsIntakeSubmission') === 'true';

  if (benefitsIntakeSubmission && returnUrl === '/submission-instructions') {
    // Users will need to add their supporting documents with BIA enabled
    return '/supporting-documents';
  }

  if (!benefitsIntakeSubmission && returnUrl === '/supporting-documents') {
    // If the toggle is reverted, take them back to the submission instructions page as no other steps are required
    return '/submission-instructions';
  }

  return returnUrl;
}
